import { useState, memo } from 'react';

import { styled } from '../../../../../stitches.config';
import { Button } from '../../../..';
import { FunctionalGroupPanel, Value } from './components/FunctionalGroupPanel';
import { Group } from './components/FunctionalGroup';
import { smartsRichFunctionalGroups } from './functionalGroups';

export type { Group, Value } from './components/FunctionalGroup';

interface FunctionalGroupFilterProps {
  value?: Value;
  onChange: (value: Value) => void;
}

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
});

const Breadcrumb = styled('div', {
  'display': 'flex',
  'flexDirection': 'row',
  'gap': '$3',
  '& > * + *:before': {
    color: '$gray9',
    content: '/',
    marginRight: '$3',
  },
});

const FunctionalGroupPanelContainer = styled('div', {
  paddingLeft: '$5',
});

function FunctionalGroupFilter(props: FunctionalGroupFilterProps) {
  const { value, onChange } = props;

  const [stack, setStack] = useState<Group[]>([
    {
      name: 'All groups',
      subgroups: smartsRichFunctionalGroups,
      smarts: [],
    },
  ]);

  function onNewPanelOpen(group: Group) {
    setStack(stack => [...stack, group]);
  }

  function onPreviousPanelOpen() {
    setStack(stack => stack.slice(0, -1));
  }

  function onPanelOpen(idx: number) {
    return () => setStack(stack => stack.slice(0, idx + 1));
  }

  return (
    <Container>
      <Breadcrumb>
        {stack.map((panel, idx) => (
          <div key={panel?.name}>
            <Button onClick={onPanelOpen(idx)} text={panel?.name} size="small" weight="minimal" />
          </div>
        ))}
      </Breadcrumb>
      <FunctionalGroupPanelContainer>
        <FunctionalGroupPanel
          {...stack[stack.length - 1]}
          value={value as Value}
          location={stack.length - 1}
          onChange={onChange}
          onNewPanelOpen={onNewPanelOpen}
          onPreviousPanelOpen={onPreviousPanelOpen}
        />
      </FunctionalGroupPanelContainer>
    </Container>
  );
}

export default memo(FunctionalGroupFilter);
